

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import Utils from "@/utilities/Utils";

    @Component({ })
    export default class PrintTextBox extends Vue {

        @Prop({ default: null }) value!: string;

        onTextInput(event: Event) {
            this.$emit("input", (event.target as HTMLInputElement)?.value);
        }

        get hasValue(): boolean {
            return !Utils.isEmptyOrWhitespace(this.value);
        }
    }
